import clientHttp, { prefixBase } from '../../clientHttp';
import ResourceHttp from '../../resourceHttp';

class VeiculoResourceHttp extends ResourceHttp {
  constructor(http, resource) {
    super();
    this.http = http;
    this.resource = resource;
  }

  consulta(params) {
    return this.http.post(`${this.resource}/consulta`, params);
  }

  filter(params) {
    return this.http.get(this.resource, { params });
  }

  showImage(veiculo, codigo) {
    return this.http.get(`${this.resource}/${veiculo}/codigo/${codigo}`);
  }

  uploadImage(veiculo, parans) {
    return this.http.post(`${this.resource}/${veiculo}/upload_imagem`, parans);
  }

  destroyImage(veiculoId, imagemId) {
    return this.http.delete(`${this.resource}/${veiculoId}/${imagemId}/destroy_imagem`);
  }

  uploadFile(veiculo, parans) {
    return this.http.post(`${this.resource}/${veiculo}/upload`, parans);
  }

  destroyFile(veiculoId, documentoId) {
    return this.http.delete(`${this.resource}/${veiculoId}/${documentoId}/destroy_file`);
  }

  listRotas(veiculo) {
    return this.http.get(`${this.resource}/${veiculo}/list_rotas`);
  }

  attachRota(id, parans) {
    return this.http.put(`${this.resource}/${id}/attach_rota`, parans);
  }

  detachRota(id, parans) {
    return this.http.put(`${this.resource}/${id}/detach_rota`, parans);
  }
}

const resource = 'veiculo';

const moduleHttp = new VeiculoResourceHttp(clientHttp, prefixBase + resource);

export default moduleHttp;
